import { Field } from "typegraph";

import { ID } from "common/entities/IEntity";

export class Tag {

	@Field()
	public id: ID;

	@Field()
	public name: string;

}



// WEBPACK FOOTER //
// ./src/panels/program/entities/Tag.ts